<template>
	<v-card elevation="0" class="top-divider py-2">
		<v-row class="ma-0" align-content="center" align="center">
			<v-toolbar-title class="text-body-1 pl-0"> フィルター {{ count + 1 }}</v-toolbar-title>
			<v-row no-gutters justify="end">
				<v-menu offset-y close-on-click>
					<template v-slot:activator="{ on, attrs }">
						<v-btn text color="red" v-bind="attrs" v-on="on"> 削除 </v-btn>
					</template>
					<v-list>
						<v-list-item @click="$emit('delete-ledger-filter')">
							<v-list-item-title color="red" class="text-body-2">本当に削除する</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-btn icon color="primary" @click="showForm = !showForm">
					<v-icon color="secondary" v-if="!showForm">mdi-chevron-down</v-icon>
					<v-icon color="secondary" v-else-if="showForm">mdi-chevron-up</v-icon>
				</v-btn>
			</v-row>
		</v-row>
		<div v-show="showForm">
			<v-select
				v-if="associationNames.length"
				v-model="ledgerFilter.base_model"
				label="参照データ"
				:items="associationNames"
				class="mt-4"
				item-text="name"
				item-value="id"
				:persistent-hint="!ledgerFilter.base_model"
				hint="選択しなければ台帳の参照データの項目から項目名を選択できます。"
				clearable
				dense
				outlined
				@change="setColumnNames"
			/>
			<div class="mt-2">
				<v-chip>{{ columnName }}</v-chip>
				<template v-if="booleanChoice.includes(ledgerFilter.condition) || columnType == 'boolean'">
					の
				</template>
				<template v-else>が</template>
				<v-chip v-if="value">{{ value }}</v-chip>
				<v-chip>{{ condition }}</v-chip>
			</div>

			<v-select
				v-model="ledgerFilter.column_name"
				label="項目名(必須)"
				:items="columnNameOptions"
				class="mt-4"
				item-text="name"
				item-value="id"
				:rules="[rules.required]"
				required
				dense
				outlined
				@change="changeColumnName"
			/>
			<v-select
				v-model="ledgerFilter.condition"
				label="条件(必須)"
				:items="conditionOptions"
				item-text="name"
				item-value="id"
				class="mt-4"
				:rules="[rules.required]"
				dense
				outlined
				@change="changeCondition"
			/>
			<template v-if="value != null">
				<template v-if="valueFomType == 'select'">
					<v-select
						v-model="ledgerFilter.value"
						label="値(必須)"
						:items="valueOptions"
						item-text="name"
						item-value="id"
						class="mt-4"
						:rules="[rules.required]"
						dense
						outlined
						@change="changeLedgerFilter"
					/>
				</template>

				<template v-else-if="valueFomType == 'string' || valueFomType == 'text'">
					<v-text-field
						v-model="ledgerFilter.value"
						label="値(必須)"
						class="mt-4"
						type="text"
						:rules="[rules.required]"
						dense
						outlined
					/>
				</template>
				<template v-else-if="valueFomType == 'integer'">
					<v-text-field
						v-model="ledgerFilter.value"
						label="値(必須)"
						class="mt-4"
						type="number"
						:rules="[rules.required]"
						dense
						outlined
					/>
				</template>
				<template v-else-if="valueFomType == 'float'">
					<v-text-field
						v-model="ledgerFilter.value"
						label="値(必須)"
						class="mt-4"
						type="text"
						:rules="[rules.required, rules.floatWithNegative]"
						dense
						outlined
					/>
				</template>
				<template v-else-if="valueFomType == 'date' || valueFomType == 'datetime'">
					<v-menu
						ref="menu"
						v-model="menu"
						:close-on-content-click="false"
						:return-value.sync="ledgerFilter.value"
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="ledgerFilter.value"
								label="値を選択してください"
								outlined
								class="mt-4"
								dense
								readonly
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="ledgerFilter.value" no-title scrollable>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false"> キャンセル </v-btn>
							<v-btn text color="primary" @click="$refs.menu.save(ledgerFilter.value)">
								決定
							</v-btn>
						</v-date-picker>
					</v-menu>
				</template>
			</template>
		</div>
	</v-card>
</template>
<script>
import rules from "../../../helper/rules"

export default {
	props: {
		ledgerFilterData: Object,
		filterOptions: Object,
		originalModelColumns: Array,
		associationNames: Array,
		count: Number,
	},
	data() {
		return {
			ledgerFilter: {
				uuid: null,
				base_model: null,
				column_name: null,
				value: null,
				condition: null,
			},
			rules: rules,
			showForm: true,
			selectedModel: null,
			selectedColumnName: null,
			columnType: null,
			valueOptions: [],
			booleanChoice: ["_present", "_blank", "_null", "_not_null", "_true", "_false"],
			menu: false,
		}
	},
	mounted() {
		this.ledgerFilter = this.ledgerFilterData
		if (this.ledgerFilter.base_model) {
			this.setSelectedModel()
		}
		if (this.ledgerFilter.column_name) {
			this.setColumnType()
		}
	},
	methods: {
		setColumnNames() {
			this.columnType = null
			this.ledgerFilter.condition = null
			this.ledgerFilter.value = null
			this.valueOptions = []
			this.setSelectedModel()
			this.changeLedgerFilter()
		},
		changeColumnName() {
			this.columnType = null
			this.ledgerFilter.condition = null
			this.ledgerFilter.value = null
			this.valueOptions = []
			this.setColumnType()
			this.changeLedgerFilter()
		},
		setSelectedModel() {
			this.selectedModel = this.associationNames.find(
				(model) => this.ledgerFilter.base_model == model.id
			)
		},
		setColumnType() {
			this.selectedColumnName = this.columnNameOptions.find(
				(c) => c.id == this.ledgerFilter.column_name
			)
			if (!this.selectedColumnName) return
			this.columnType = this.selectedColumnName.type
			if (this.selectedColumnName.options.length) {
				this.valueOptions = this.selectedColumnName.options
			}
		},
		changeCondition() {
			this.ledgerFilter.value = null
			if (this.booleanChoice.includes(this.ledgerFilter.condition)) this.ledgerFilter.value = true
			this.changeLedgerFilter()
		},
		changeLedgerFilter() {
			this.$emit("change-ledger-filter", this.ledgerFilter)
		},
	},
	computed: {
		columnNameOptions() {
			if (this.selectedModel) {
				return this.selectedModel.columns.filter((c) => !c.meta_tag)
			} else {
				return this.originalModelColumns.filter((c) => !c.meta_tag)
			}
		},
		columnName() {
			if (this.selectedColumnName) {
				return this.selectedModel
					? `${this.selectedColumnName.name}(${this.selectedModel.name})`
					: this.selectedColumnName.name
			} else {
				return "項目名を選択してください"
			}
		},
		conditionOptions() {
			if (!this.selectedColumnName) return []
			if (this.selectedColumnName.options.length && this.columnType != "boolean") {
				return this.filterOptions.conditions.enum
			}
			switch (this.columnType) {
				case "integer":
				case "float":
					return this.filterOptions.conditions.number
				case "string":
				case "text":
					return this.filterOptions.conditions.text
				case "date":
				case "datetime":
					return this.filterOptions.conditions.date
				case "boolean":
					return this.filterOptions.conditions.boolean
				default:
					return []
			}
		},
		value() {
			if (
				this.booleanChoice.includes(this.ledgerFilter.condition) ||
				this.columnType == "boolean"
			) {
				return null
			} else if (this.ledgerFilter.value == null && this.ledgerFilter.column_name) {
				return "値を入力してください"
			} else if (this.ledgerFilter.value == null) {
				return null
			} else if (this.valueOptions.length) {
				const selectedValue = this.valueOptions.find((v) => v.id == this.ledgerFilter.value)
				if (selectedValue) return selectedValue.name
			} else {
				return this.ledgerFilter.value
			}
		},
		condition() {
			const selectedCondition = this.conditionOptions.find(
				(c) => c.id == this.ledgerFilter.condition
			)
			if (selectedCondition) {
				return selectedCondition.name
			} else {
				return "条件を選択してください"
			}
		},
		valueFomType() {
			if (this.valueOptions.length) return "select"
			return this.columnType
		},
	},
	watch: {
		ledgerFilterData(newValue, oldValue) {
			this.ledgerFilter = newValue
		},
		deep: true,
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/shared/color.scss";
.ledger-filter-form {
	padding: 8px;
	&:not(:first-child) {
		border-top: 1px solid whitesmoke;
	}
}
.v-toolbar__content {
	padding: 0;
}
</style>